import { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";

export default function BackToTop() {
  const [isVisible, setIsVisible] = useState(false);

  // Toggle visibility based on scroll position
  useEffect(() => {
    const toggleVisibility = () => {
      // Show button if scrolled down more than 300px
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <Button
      onClick={scrollToTop}
      style={{
        position: "fixed",
        bottom: "30px",
        right: "30px",
        backgroundColor: "#405189", // Matches your Sign Up button color
        border: "none",
        borderRadius: "50%",
        width: "50px",
        height: "50px",
        zIndex: 1000,
        opacity: isVisible ? "1" : "0",
        visibility: isVisible ? "visible" : "hidden",
        transition: "all 0.3s ease-in-out",
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.15)",
      }}
      className="d-flex align-items-center justify-content-center"
      aria-label="Back to top"
    >
      {/* Up Arrow SVG Icon */}
      <svg
        xmlns="http://w3.org"
        width="24"
        height="24"
        fill="white"
        viewBox="0 0 16 16"
      >
        <path
          fillRule="evenodd"
          d="M8 12a.5.5 0 0 0 .5-.5V5.707l2.146 2.147a.5.5 0 0 0 .708-.708l-3-3a.5.5 0 0 0-.708 0l-3 3a.5.5 0 1 0 .708.708L7.5 5.707V11.5a.5.5 0 0 0 .5.5z"
        />
      </svg>
    </Button>
  );
}
